module.exports = __webpack_public_path__ + "img/gc_country_flag_ht.9462daeb.svg";